import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';
import { Navigate } from 'react-router-dom';

import { useStudioModel } from './StudioModelProvider.js';

/**
 * Blocks studio product routes until the model application is approved.
 * Application + auth routes stay reachable outside this guard.
 */
export function ApplicationGate({ children }: { children: ReactElement }): ReactElement {
  const { profile, isLoading } = useStudioModel();

  if (isLoading) {
    return <p style={{ color: 'var(--fm-color-text-muted)' }}>{t('common.studio.dashboard.loading')}</p>;
  }

  if (!profile?.canBroadcast) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
